import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import {DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS} from 'common/types';
import DATA_FILTERS from 'go/components/common/dataFilters';

const getItem = (itemCollection, filterKey, id) => {
  if (itemCollection) {
    return _.filter(itemCollection, (item) => {
      return item[filterKey] === id;
    });
  }
  return id;
};

const getChildItems = (itemCollection, filterKey, item) =>
  _.flatMap(item.children, (child) => {
    return getItem(itemCollection, filterKey, child);
  });

const mergeItems = (itemCollection, filterKey, childFilterKey, item) => {
  const itemObj = _.get(
    getItem(itemCollection, childFilterKey, filterKey ? item[filterKey] : item),
    0
  );
  return {
    ...itemObj,
    [filterKey]: item[filterKey],
    children: getChildItems(itemCollection, childFilterKey, item),
  };
};

const getChildren = (items, lookupKey, name) => {
  return _.result(
    _.find(items, function (obj) {
      return obj[lookupKey] === name;
    }),
    'children'
  );
};

export const DependentSelectOptionFilterListener = (props) => {
  const {preFilter, contents, itemCodes, stateContext, saveToContext, dataKey} = props;
  const [itemCollection] = useState(_.get(props, props.itemCodes.data), []);
  const [refData, setRefData] = useState(_.get(props, 'refData', []));
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (preFilter) {
      const filterRefData = DATA_FILTERS[preFilter](props);
      setRefData(filterRefData);
    }
  }, [props.refData]);

  useEffect(() => {
    if (!_.isEmpty(refData)) {
      let data = dataKey ? refData[dataKey] : refData;
      let selectOptions = _.chain(data)
        .map((item) => {
          return mergeItems(
            itemCollection,
            itemCodes.filterKey,
            itemCodes.childFilterKey,
            item
          );
        })
        .value();
      let contextData = {};
      if (!_.isEmpty(_.get(props, 'rootContextObj'))) {
        contextData = JSON.parse(JSON.stringify(_.get(props, 'rootContextObj')));
      }
      contextData[stateContext.key] = _.map(selectOptions, (act) =>
        _.omit(act, 'children')
      );
      _.each(stateContext.sets, (set) => {
        const selectedKey = _.get(props, set.selectedKey);
        if (!_.isEmpty(selectedKey)) {
          contextData[set.childKey] = getChildren(
            selectOptions,
            itemCodes.lookupKey,
            selectedKey
          );
        }
      });
      saveToContext(stateContext.rootKey, contextData);
      setDone(true);
    }
  }, [refData]);

  return (
    <>
      {done
        ? contents.map((entry, index) => {
            return <ContentDispatch config={entry} key={entry.title} />;
          })
        : null}
    </>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  saveToContext: (contextName, data) => {
    dispatch({
      type: DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
      meta: {objectType: contextName, optional: true},
      payload: data,
    });
  },
});

export default connect(
  null,
  mapDispatchToProps
)(connectDynamic(DependentSelectOptionFilterListener));
